import FontLoaderHead from '@swey/heyday-base/js/services/FontLoaderHead';

export default function addLoadedFonts(): void {
	FontLoaderHead.addLoadedFont('wf-roboto-condensed-loaded');
}
